// extracted by mini-css-extract-plugin
export var textInput = "_fl-0";